import { event, setOptions, bootstrap, optIn, optOut } from 'vue-gtag';
import { ANALYTICS_KEY } from '@/../region.json';
import { hasAnalyticsConsent } from './consent';

// region.json holds the *name* of the env var, not the id itself.
function analyticsId() {
  return process.env[ANALYTICS_KEY];
}

/** Send events to google analytics
 * @param {string} name -> 'Click' | 'Login' etc
 * @param {{event_category: string, event_label: string}} opts -> event_category: 'FAQPage', event_label: "How do I change my email address?"
 */
export function sendAnalytics(name, opts) {
  // Central gate, so a caller that forgets to check consent cannot leak an
  // event. Callers still check, to avoid doing the work at all.
  if (!hasAnalyticsConsent()) {
    return;
  }
  event(name, opts);
}

// Injects gtag.js. vue-gtag is registered with `bootstrap: false` in main.js, so
// nothing is loaded and no cookie is set until this runs.
export function enableAnalytics() {
  setOptions({
    config: { id: analyticsId() },
  });

  // Clears any ga-disable flag left by a decline earlier in this session, so
  // accepting afterwards actually takes effect.
  optIn();

  return bootstrap();
}

// Sets window['ga-disable-<id>'], which stops gtag from sending further hits.
// It does not remove cookies that were already set - clearNonEssentialCookies
// does that - and it cannot un-inject gtag.js, which is why withdrawing consent
// mid-session is followed by a reload.
export function disableAnalytics() {
  setOptions({
    config: { id: analyticsId() },
  });

  optOut();
}
